import { getGodModeOptionsState } from '@mote/helpers/identity'
import { useGenericRequestHandler } from '../../../handlers'
import type { GenericHandlerValues, SearchUsers } from '../../../models'

export interface AccountUserSearchPayload {
  searchTerm: string
}

export interface AccountUserSearchResponse {
  searchResults: SearchUsers
}

export type UseAccountUserSearchMutationValues = GenericHandlerValues<
  AccountUserSearchResponse,
  'POST'
>

export const useAccountUserSearchMutation = (
  institutionId?: string
): UseAccountUserSearchMutationValues => {
  const godModeState = getGodModeOptionsState(institutionId)
  return useGenericRequestHandler({
    route: 'v1/t/searchUsers',
    method: 'POST',
    options: {
      json: godModeState.options,
      shouldNotStoreAuthData: godModeState.inGodMode
    }
  }) as UseAccountUserSearchMutationValues
}
